import { gql } from "../../apis/__generated__";

export const GET_ROLES = gql(/* GraphQL */ `
  query roles(
    $block: Block_height
    $first: Int
    $orderBy: Role_orderBy
    $orderDirection: OrderDirection
    $skip: Int
    $where: Role_filter
  ) {
    roles(
      block: $block
      first: $first
      orderBy: $orderBy
      orderDirection: $orderDirection
      skip: $skip
      where: $where
    ) {
      id
      account
    }
  }
`);
